// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style_markdown__JsmRt"};